import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-804d6e56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "working-site-assigned-users-section pb-8" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "title-section-spacing bg-white z-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold block text-left" }, "Dipendenti aggiunti al cantiere", -1))
const _hoisted_5 = {
  key: 0,
  class: "working-sites-users w-full"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titles-working-site-users grid grid-cols-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "first text-left" }, "Nome dipendente"),
  /*#__PURE__*/_createElementVNode("p", { class: "second col-span-2 text-left" }, "Ruolo assegnato"),
  /*#__PURE__*/_createElementVNode("p", { class: "third text-left" })
], -1))
const _hoisted_7 = { class: "users-list list overflow-y-hidden" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "view-more-users font-bold justify-between items-center pt-2 pr-8 cursor-pointer select-none text-right text-primary-600" }, "Vedi tutti i dipendenti", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorkingSiteAssignedUser = _resolveComponent("WorkingSiteAssignedUser")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AssignUser = _resolveComponent("AssignUser")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "add-document text-primary block float-right font-bold",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showUserAssignmentDialog()))
        }, "Aggiungi dipendente"),
        _hoisted_4
      ]),
      (_ctx.users.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                return (_openBlock(), _createBlock(_component_WorkingSiteAssignedUser, {
                  key: user.id,
                  "user-id": user.id,
                  "user-name": `${user.name} ${user.surname}`,
                  "is-foreman": user.workSiteAssignments[_ctx.workingSiteId].isForeman,
                  "is-suspended": !user.workSiteAssignments[_ctx.workingSiteId].isEnabled,
                  "working-site-id": _ctx.workingSiteId,
                  "working-site-name": _ctx.workingSiteName,
                  onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadUsers()))
                }, null, 8, ["user-id", "user-name", "is-foreman", "is-suspended", "working-site-id", "working-site-name"]))
              }), 128)),
              _createVNode(_component_router_link, {
                class: "block focus:outline-none focus:shadow-outline",
                type: "button",
                to: `/working-sites/${_ctx.workingSiteId}/users`
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isShowingUserAssignment)
      ? (_openBlock(), _createBlock(_component_AssignUser, {
          key: 0,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hideUserAssignmentDialog())),
          "working-site-id": _ctx.workingSiteId
        }, null, 8, ["working-site-id"]))
      : _createCommentVNode("", true)
  ]))
}